require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-water-supply-sanitation-project.json") })
        }
      }, "path---en-us-project-water-supply-sanitation-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-water-supply-sanitation-project!./.cache/json/en-us-project-water-supply-sanitation-project.json
// module id = 572
// module chunks = 231608221292675